
import React from "react";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/common/Logo";
import BrandedLoader from "@/components/ui/BrandedLoader";

interface LoadingNavbarProps {
  handleNavigate: (path: string) => (e: React.MouseEvent) => void;
}

export const LoadingNavbar = ({ handleNavigate }: LoadingNavbarProps) => {
  return (
    <header className="bg-yarn-slate/95 text-white border-b border-white/10 shadow-md backdrop-blur-sm">
      <div className="container flex h-16 items-center justify-between">
        <div className="flex items-center gap-2">
          <Button variant="ghost" className="p-1 text-white hover:text-white/80 hover:bg-white/10" onClick={handleNavigate("/")}>
            <div className="flex items-center">
              <Logo variant="dark" />
            </div>
          </Button>
        </div>
        
        <div className="flex items-center h-10">
          <div className="w-24 flex items-center justify-center">
            <div className="w-6 h-6">
              <BrandedLoader />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
